export default "/kiban/_next/static/images/dxfDataOutput-c3c5b78792586523898a641eb4874fb6.png";